import { createClient } from "@supabase/supabase-js";
import type { Database } from "@colab/shared/database.types";

// Browser-only Supabase client. The session is persisted by supabase-js in
// localStorage and refreshed automatically via onAuthStateChange. There is no
// server-rendered context in this SPA, so we do NOT use @supabase/ssr here.
//
// Service-role keys never reach this bundle — see apps/api/src/lib/supabase.ts
// for the worker-side admin client.

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    "Supabase env vars missing. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in apps/web/.env.local",
  );
}

export const supabase = createClient<Database>(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
